module.exports = __webpack_public_path__ + "img/png_tszp_3@2x.0ee04e00.png";